// eslint-disable-next-line import/order
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

import { styled, type StyledProps } from '@compiled/react';

// eslint-disable-next-line import/order
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIAnswerBodyWrapper: ComponentType<
	{
		isReadingAids?: boolean;
		serveDefinitionsUXExp?: boolean;
	} & ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.div<{
	isReadingAids?: boolean;
	serveDefinitionsUXExp?: boolean;
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
}>(({ isReadingAids, serveDefinitionsUXExp }) =>
	isReadingAids
		? {
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'flex-start',
				gap: token('space.100'),
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
				padding: serveDefinitionsUXExp
					? `${token('space.075')} ${token('space.200')} ${token('space.050')}`
					: `${token('space.075')} ${token('space.300')} ${token('space.050')}`,
			}
		: {
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'flex-start',
				gap: token('space.100'),
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
				padding: `${token('space.100')} ${token('space.300')} 0px ${token('space.300')}`,
			},
);
